import BookModal from './BookModalContainer';

export default BookModal;
